<script setup>
import { onMounted, ref,unref, watch, toRef} from 'vue'
import { DateTime, Settings } from 'luxon';
import axios from 'axios';
import config from '@/../../../../config_public.mjs';
const props = defineProps(['memberStatus']);
let oneSearchDone = false;

const receiptCustomMessage = ref('')

const numberOfCopies = ref(1);

watch(() => props.memberStatus,function(val){
    console.log('member:',val)
    console.log('member2:',props.memberStatus)
    oneSearchDone = true;
});

const showReceipt = ()=>{
    if(props.memberStatus){
        return Object.keys(props.memberStatus).length > 0
    }
    return false;
}

const showSearchMessage = ()=>{
   
    return !oneSearchDone ||  props.memberStatus===null;
}

const decrementNumberOfCopies = ()=>{
    if(numberOfCopies.value > 1){
        numberOfCopies.value--;
    }
}

const incrementNumberOfCopies = ()=>{
    if(numberOfCopies.value < 5){
        numberOfCopies.value++;
    }
}

const print = ()=>{

    // alert(`Nombre de copies: ${numberOfCopies.value}`)
    
    var appscheme = 'tmprintassistant://';           //scheme name                                                                           Input condition:Required
    var host = 'tmprintassistant.epson.com/';        //host name                                                                             Input condition:Required
    var action       = 'print?';                     //action name                                                                           Input condition:Required
    var query_success = 'success';                   //URL to be displayed when TM Print Assistant has terminated normally.                  Input condition:Can be omitted
    var query_ver = 'ver';                           //Version number                                                                        Input condition:Required
    var query_datatype = 'data-type';                //Type of print data                                                                    Input condition:Required
    var query_data = 'data';                         //Print data                                                                            Input condition:Required
    var query_reselect = 'reselect';                 //Reconfiguration of printer upon communication error                                   Input condition:Can be omitted (Default : no)
    var query_cut = 'cut';                           //Cutter setting                                                                        Input condition:Can be omitted (Default : no)
    var query_fittowidth = 'fit-to-width';           //Scaling up or down print data in accordance with paper width Supported data-type: pdf Input condition:Can be omitted (Default : no)
    var query_paperwidth = 'paper-width';            //Specifying paper width (mm)                                                           Input condition:Can be omitted (Default : 80)
    var pdfData = '';
    var pdfPath = './receipt.pdf';                   //Path of pdf file
    
    var xmlData = "";
    
    // Header
    xmlData +=  '<epos-print xmlns="http://www.epson-pos.com/schemas/2011/03/epos-print">\n';
    
    for(var i=0; i < numberOfCopies.value; i++){
        xmlData +=        '<text smooth="true" align="center"/>\n';
        
        // Contact information
        xmlData +=  '<text dh="false" dw="false" em="false" align="center">Loterie moitié-moitié&#10;</text>\n' +
                    '<text dh="true" dw="false" em="true" align="center">Chevaliers de Colomb&#10;</text>\n' +
                    '<text dh="false" dw="false" em="true" align="center">CONSEIL 7188&#10;</text>\n' +
                    '<text dh="false" dw="false" em="false">  Saint-François-de-Madawaska   &#10;</text>\n' +
                    '<text dh="false" dw="false" em="false" font="font_b">  Tél.: '+config.organisation.phone_number+'   &#10;</text>\n' +
                    '<text dh="false" dw="false" em="false" font="font_c">https://chevaliersaintfrancois7188.com &#10;</text>\n';
    
        // Logo
        xmlData +=  generate_logo_image();
        
        // Client Message 1    
        xmlData +=  '<text dh="false" dw="false" em="false" font="font_b" ul="true">Le client est le seul responsable de &#10;</text>\n' +
                    '<text dh="false" dw="false" em="false" font="font_b" ul="true">renouveler son numéro chaque semaine &#10;</text>\n' +
                    '<text linespc="20" ul="false">&#10;</text>';
    
        //- Client Number
        xmlData +=  '<text linespc="30" em="false" dh="false">Numéro: </text>\n' +
                    '<text linespc="20" em="false" dh="false">'+props.memberStatus.number+'&#10;</text>';
    
        // Client Name
        xmlData +=  '<text linespc="30" em="true" dh="true">'+escapeXml(props.memberStatus.firstname+' '+props.memberStatus.lastname)+'&#10;</text>\n' +
                    '<text linespc="20" em="false" dh="false">&#10;</text>';
        
        // Telephone numbers
        xmlData += generate_telephone_numbers();  
        
        // Last payment
        xmlData +=  '<text linespc="20">&#10;</text>' +
                    '<text em="false" linespc="30">Dernier paiement de&#10;</text>\n' +
                    '<text em="true" smooth="true" dw="true" dh="true">'+props.memberStatus.amount+'$&#10;</text>\n' +
                    '<text em="false" smooth="true" dw="false" dh="false">Reçu le&#10;</text>\n' +
                    '<text em="true">'+DateTime.fromISO(props.memberStatus.date,{zone:config.general.timezone}).setLocale(config.general.locale).toFormat(config.general.formats.datetime_view_alt)+'&#10;</text>\n' +
                    '<text linespc="20">&#10;</text>';

        // Drawing date
        xmlData += generate_drawing_date();     

        // Point of sale
        xmlData +=  '<text em="false" linespc="30">Point de vente&#10;</text>\n' +
                    '<text em="true">'+escapeXml(props.memberStatus.pos_name?props.memberStatus.pos_name:'N/D')+'&#10;</text>\n' +
                    '<text linespc="20">&#10;</text>';
        
        // Client Message 2
        xmlData +=  '<text linespc="30" em="false" font="font_d" ul="true">Vous devez payer le lundi 21h pour&#10; participer au tirage du mardi de &#10;chaque semaine.&#10;</text>\n' +
                    '<text linespc="20" ul="false">&#10;</text>' +
                    '<text linespc="30" em="true" dh="true" reverse="true">Garder le reçu pour réclamer votre prix&#10;</text>\n';

        // Custom receipt message
        xmlData += generate_custom_message();     

        // Lottery permit
        xmlData +=  '<text linespc="20" dh="false" reverse="false">&#10;</text>' +
                    '<text em="false" font="font_c">Permis de loterie: '+escapeXml(config.organisation.permit_number)+'&#10;</text>\n';

        // Invoice Number
        xmlData +=  '<text em="false" font="font_c"># '+props.memberStatus.invoiceNumber+'&#10;</text>\n';
            
        // Barcode
        xmlData +=  '<text>&#10;</text>' +
                    '<barcode type="code39" font="font_a" width="2" height="75" hri="below">'+props.memberStatus.number+'</barcode>\n';

        // Footer
        xmlData +=  '<cut type="feed"/>\n';
    }
    xmlData +=  '</epos-print>';

    console.log(xmlData);
    
    function generate_drawing_date() {
        
        let ret = '<text reverse="false"></text>';
        
        if (props.memberStatus.new_endDate && props.memberStatus.current_endDate) {

            if (props.memberStatus.amount == 2) {
                ret +=  '<text linespc="30" em="false" >Payé pour le tirage du&#10;</text>\n' +
                        '<text em="true" ul="true" >' + DateTime.fromISO(props.memberStatus.new_endDate, { zone: config.general.timezone }).setLocale(config.general.locale).toFormat(config.general.formats.end_date_view_alt) + '&#10;</text>\n';
            }
            else {
                ret +=  '<text linespc="30" em="false">Payé pour les tirages du&#10;</text>\n' +
                        '<text em="false">' + DateTime.fromISO(props.memberStatus.current_endDate, { zone: config.general.timezone }).setLocale(config.general.locale).toFormat(config.general.formats.end_date_view_alt) + '&#10;</text>' +
                        '<text em="false"> au &#10;</text>' + 
                        '<text em="true" ul="true"> ' + DateTime.fromISO(props.memberStatus.new_endDate, { zone: config.general.timezone }).setLocale(config.general.locale).toFormat(config.general.formats.end_date_view_alt) + '&#10;</text>\n';
            }
        }
        else {
            ret +=  '<text linespc="30" em="false">Payé jusqu\'au tirage du&#10;</text>\n' +
                    '<text em="true" ul="true">' + DateTime.fromISO(props.memberStatus.endDate, { zone: config.general.timezone }).setLocale(config.general.locale).toFormat(config.general.formats.end_date_view_alt) + '&#10;</text>\n';

        }
        ret += '<text em="false" ul="false" reverse="false">&#10;</text>';
        return ret;
    }


    function generate_custom_message(){
        
        let ret = '';
        
        if(receiptCustomMessage.value != ''){
            ret +=  '<text linespc="20" dh="false">&#10;</text>' +
                    '<text linespc="30" em="true">'+receiptCustomMessage.value+'&#10;</text>\n';
        }
        
        return ret;
    }


    function generate_telephone_numbers(){
        
        let ret = '';
        
        if(props.memberStatus.telephone1){
            ret +=  '<text linespc="30" em="false" dh="false">'+ formatTelephone(props.memberStatus.telephone1)+'&#10;</text>\n';
        } 
        if(props.memberStatus.telephone2){
            ret +=  '<text linespc="30" em="false" dh="false">'+ formatTelephone(props.memberStatus.telephone2)+'&#10;</text>\n';
        }  
        
        return ret;
    }

    function generate_logo_image(){
    
        return '<image width="150" height="150" align="center">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</image>';    }


    function sendXml() {
        var success = window.location.href;
        var ver = '1';
        var datatype = 'eposprintxml';
        var htmlData = '';
        var reselect = 'yes';
        var urlData = '';

        urlData = appscheme + host + action + 
            query_success + '=' + encodeURIComponent(success) + '&' + 
            query_ver + '=' + ver + '&' + 
            query_datatype + '=' + datatype + '&' + 
            query_reselect + '=' + reselect + '&' + 
            query_data + '=' + encodeURIComponent(xmlData);
        location.href = urlData;
    }

    function escapeXml(unsafe) {
        return unsafe.replace(/[<>&'"]/g, function (c) {
            switch (c) {
                case '<': return '&lt;';
                case '>': return '&gt;';
                case '&': return '&amp;';
                case '\'': return '&apos;';
                case '"': return '&quot;';
            }
        });
    }

    sendXml()
}


onMounted(async ()=>{
    try{
        const res = await axios.get(`/api/v1/settings/receiptMessage`);

        if(res.data && typeof res.data.value!='undefined'){

            receiptCustomMessage.value = res.data.value;
        }
    }
    catch(err){
        console.error(err);
    }
})

// TODO this should be in utilities module
const formatTelephone = (telephone)=>{
    
    let ret = telephone;
    
    const areaCode = telephone.substring(0,3);
	const middle = telephone.substring(3,6);
	const last = telephone.substring(6,10);
    
	if(telephone.length > 6){
        ret = `(${areaCode}) ${middle}-${last}`;
    }
	else if(telephone.length > 3){
        ret = `(${areaCode}) ${middle}`; 
    }
	else if(telephone.length > 0){
        ret = `(${areaCode}`;
    }
    return ret;
}
</script>

<template lang="pug">
div.uk-margin-large.uk-flex.uk-flex-center
    div
        template(v-if="showReceipt()")
                          
            div#receiptViewer

                //- Contact information
                div(style="font-weight: light; font-size:1.2em;") Loterie moitié-moitié
                div(style="font-weight: bold; font-size:1.2em;") Chevaliers de Colomb
                div(style="font-weight:bold;") CONSEIL 7188
                div(style="font-weight:bold;") Saint-Francois-de-Madawaska 
                div(style="font-weight:light;") Tél.: {{ config.organisation.phone_number }}
                div(style="font-weight:light;font-size:0.8em;") https://chevaliersaintfrancois7188.com
                
                //- Logo
                img(src="/public/logo.png")

                //- Client Message 1
                div(style="text-decoration:underline;")
                    | Le client est le seul responsable de renouveler son numéro chaque semaine.
                
                //- Client Number
                br
                div(style="margin: 5px 0 0 0;font-weight: normal;font-size: 1em;")
                    | Numéro: 
                    b {{props.memberStatus.number}}
                
                //- Client name
                div(style="margin: 10px 0;font-weight: bold;font-size: 1.2em;") {{props.memberStatus.firstname}} {{props.memberStatus.lastname}}             
                
                //- Telephone numbers
                template(v-if="props.memberStatus.telephone1")
                    div(style="font-weight: normal;font-size: 1em;font-style: italic;") {{ formatTelephone(props.memberStatus.telephone1) }}
                template(v-if="props.memberStatus.telephone2")
                    div(style="font-weight: normal;font-size: 1em;font-style: italic;") {{ formatTelephone(props.memberStatus.telephone2) }}
                br

                //- Last payment
                div Dernier paiement de 
                div(style="font-weight:bold;font-size:2em;") {{props.memberStatus.amount}} $
                div Reçu le
                div(style="font-weight:bold;margin-bottom:10px;") {{DateTime.fromISO(props.memberStatus.date,{zone:config.general.timezone}).setLocale(config.general.locale).toFormat(config.general.formats.datetime_view_alt)}}
                
                //- Drawing date
                template(v-if="props.memberStatus.new_endDate && props.memberStatus.current_endDate")
                    template(v-if="props.memberStatus.amount==2")
                        div Payé pour le tirage du
                        div(style="font-weight:bold;margin-bottom:10px;text-decoration:underline;") {{ DateTime.fromISO(props.memberStatus.new_endDate,{zone:config.general.timezone}).setLocale(config.general.locale).toFormat(config.general.formats.end_date_view_alt) }}
                    template(v-else)
                        div Payé pour les tirages du
                        div(style="font-weight:bold;margin-bottom:10px;") 
                            div {{ DateTime.fromISO(props.memberStatus.current_endDate,{zone:config.general.timezone}).setLocale(config.general.locale).toFormat(config.general.formats.end_date_view_alt) }} 
                            div(style="margin: -8px 0;font-weight: 100;") au 
                            div(style="text-decoration:underline;") {{ DateTime.fromISO(props.memberStatus.new_endDate,{zone:config.general.timezone}).setLocale(config.general.locale).toFormat(config.general.formats.end_date_view_alt) }}
                template(v-else)
                        div Payé jusqu'au tirage du
                        div(style="font-weight:bold;margin-bottom:10px;text-decoration:underline;") {{ DateTime.fromISO(props.memberStatus.endDate,{zone:config.general.timezone}).setLocale(config.general.locale).toFormat(config.general.formats.end_date_view_alt) }}

                //- Point of sale
                div Point de vente
                div(style="font-weight:bold;margin-bottom:10px;") {{props.memberStatus.pos_name?props.memberStatus.pos_name:'N/D'}}
              
                //- Client Message 2
                div(style="text-decoration:underline;margin-bottom:10px;") 
                    | Vous devez payer le lundi 21h pour participer au tirage du mardi de chaque semaine. 
                div(style="margin-bottom:10px;background: #727272;color: white;padding: 3px;")
                    | Gardez votre reçu pour réclamer votre prix
                
                //- Custom receipt message
                div(style="font-weight:lighter;margin-bottom:10px;") {{ receiptCustomMessage }}
                
                //- Lottery permit
                div(style="font-weight:lighter;font-size:0.8em;")
                    | Permis de loterie: {{ config.organisation.permit_number }}

                //- Invoice Number
                div(style="font-weight:lighter;font-size:0.8em;")
                    | # {{props.memberStatus.invoiceNumber }}
            
            div.uk-width-1-1.uk-margin
                label.uk-form-label Nombre de copies 
                div.uk-form-controls
                    button.uk-button.uk-button-primary.uk-width-2-5(@click="decrementNumberOfCopies()") -
                    input.uk-input.uk-width-1-5(type="text" readonly v-model="numberOfCopies" style="text-align:center;")
                    button.uk-button.uk-button-primary.uk-width-2-5(@click="incrementNumberOfCopies()") +
            
            button.uk-button.uk-button-primary.uk-width-1-1.uk-margin(@click="print") 
                span(uk-icon="print")    
                | Imprimer
            
        template(v-else-if="showSearchMessage()")
            | 
        template(v-else)
            | Aucune transaction trouvée
</template>


<style scoped>
#receiptViewer{
    text-align: center;
    width:300px;
    background:rgb(244, 244, 244);
    border:solid 1px #e1e1e1;
    padding: 25px 20px;
}

img{
    max-width: 100px;
}
</style>
